export function ContactPage() {
  return (
    <section className="contact-page" aria-labelledby="contact-title">
      <div className="contact-page-intro">
        <span className="section-eyebrow">Support & feedback</span>
        <h1 id="contact-title">Contact Aspirant</h1>
        <p>
          For app support, account help, content feedback or a partnership
          enquiry, contact the Aspirant team directly.
        </p>
      </div>

      <div className="contact-grid">
        <article className="contact-email-card">
          <span className="contact-card-label">Email support</span>
          <h2>hamza@devzona.com</h2>
          <p>
            Please include your app platform, the screen or topic involved and
            a short description of the issue so we can help efficiently.
          </p>
          <a className="button button-primary" href="mailto:hamza@devzona.com">
            Email Aspirant support
          </a>
        </article>

        <article className="contact-help-card">
          <span className="contact-card-label">Before you write</span>
          <h2>Useful details</h2>
          <ul>
            <li>Your name and the email linked to your account.</li>
            <li>Whether you use Android, iPhone or the web portal.</li>
            <li>The subject, lesson or feature you need help with.</li>
            <li>A screenshot if you are reporting a technical issue.</li>
          </ul>
        </article>
      </div>

      <p className="contact-note">
        Aspirant is an independent DevZona Labs learning platform and is not
        affiliated with FPSC or any government institution.
      </p>
    </section>
  );
}
